import ScrollContainer from "react-indiana-drag-scroll";
import { ContactsTabsDesktop } from "../desktop";
import styles from "./styles.module.scss";

export const ContactsTabsMobile = () => {
  return (
    <ScrollContainer className={styles["scroll-container"]} horizontal>
      <ContactsTabsDesktop />
    </ScrollContainer>
  );
};
